import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@emotion/react';
import { OutlineButton } from 'shared-components/Buttons/Outline';
import { Container } from 'shared-components/Container';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { PersonStatus } from 'utils/enum';
import { getPersonMedicalRecords } from 'pages/MedicalInformation/utils';

export const Consent = ({ handleConsentModal }) => {
  const theme = useTheme();
  const { person } = useGetPersonAndAttributes();
  const hasWithdrawn = person?.state?.status === PersonStatus.Withdrawn;
  const personInfo = getPersonMedicalRecords(person?.attributes, {
    consentDate : '',
  });

  return (
    <Container
      maxWidth={{ xl: '800px' }} mb={4}>
      <Typography
        fontFamily='Montserrat' fontWeight='700' variant='h6' mb={1}>
        Consent
      </Typography>
      <Typography
        variant='body2' mb={4} color='primary.grey5'>
        {hasWithdrawn ? 'Withdrawn' : 'Accepted'} on {personInfo?.consentDate}
      </Typography>
      <Typography
        variant='body2' mb={2}>
        The <strong>WCG IRB</strong> reviewed this Registry. The WCG IRB is a
        group of people who review research studies to protect the rights and
        welfare of research participants. If you have questions about your
        rights as a research participant, if you are not able to resolve your
        concerns with the Registry staff, if you have a concern or complaint, or
        if you have general questions about what it means to be in a research
        Registry, you can call 1-855-818-2289 or email{' '}
        <a
          href='https://www.neirb.com' target='_blank' rel='noreferrer'>
          researchquestions@wcgirb.com
        </a>
        .
      </Typography>
      <Typography
        variant='body2' mb={2}>
        You can withdraw your consent at any time. If you are considering
        withdrawing from this registry please contact us at{' '}
        <a
          href='mailto:registry@pkdcure.org'>registry@pkdcure.org</a>. The
        Polycystic Kidney Disease Foundation will always respect your decision
        to leave.
      </Typography>
      <Typography
        variant='body2' mb={2}>
        You can withdraw by choosing not to participate in registry activities
        any more. This means that the foundation will no longer contact you to
        complete surveys. All of the valuable information you have provided so
        far will remain in the Registry and contribute to our research.
      </Typography>
      <Typography
        variant='body2' mb={4}>
        You can also withdraw from the Registry completely. If you choose to do
        this all of the information you have provided about yourself and all
        surveys that you have completed will be deleted and would no longer be
        available to researchers. Withdrawing in this way means that your
        information will not contribute to future research but it would not be
        possible to remove data from research that has already taken place.
      </Typography>
      <OutlineButton
        width='100%'
        fontFamily='Montserrat'
        color={theme.palette.primary.blue1}
        borderColor={theme.palette.primary.blue1}
        text='Go to consent'
        onClickHandler={() => handleConsentModal(true)}
      />
    </Container>
  );
};
